export default __webpack_public_path__ + "static/media/me.f93cb0ee.png";